import { Injectable, NgZone } from '@angular/core';
import { LocationsMdmHubService } from '@era/core';
import { Store } from '@ngrx/store';
import { DeviceActiveSyncsStoreActions } from '../sub-features/device-sync/device-active-syncs-store';

@Injectable()
export class ActiveDeviceSyncsSignalR {
  constructor(
    private readonly activeDeviceStore: Store<number>,
    private readonly zone: NgZone,
    private readonly locationsMdmHubService: LocationsMdmHubService
  ) {}

  public async initialize() {
    // Ensure connection is ready using the centralized hub service method
    await this.locationsMdmHubService.ensureConnected();

    // Join the SignalR group
    await this.locationsMdmHubService.hubConnection.invoke('JoinDeviceSyncGroup');

    // Set up the event listener
    this.locationsMdmHubService.hubConnection.on('OnActiveDeviceSyncsRetrieved', (currentActiveSyncs: number) => {
      this.zone.run(() => {
        this.activeDeviceStore.dispatch(
          DeviceActiveSyncsStoreActions.SignalRActions.activeDeviceSyncsUpdated({ currentActiveSyncs })
        );
      });
    });
  }

  public async cleanup() {
    // Leave the SignalR group and remove the event listener
    await this.locationsMdmHubService.hubConnection.invoke('LeaveDeviceSyncGroup');
    this.locationsMdmHubService.hubConnection.off('OnActiveDeviceSyncsRetrieved');
  }
}
